<template>
    <div ref="shareLinkTableContainer">
        <vs-table :data="docList" class="mt-4" stripe>
            <template slot="thead">
				<vs-th>Ajouté par</vs-th>
                <vs-th>Nom du document</vs-th>
                <vs-th>Catégorie</vs-th>
                <vs-th>Date</vs-th>
                <vs-th>Lien vers le document</vs-th>
                <vs-th></vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="index" v-for="(item, index) in data">
					<vs-td :id="'user' + item.id">
						<vx-tooltip
							:text="getUserName(item.user_id)"
							position="top"
							style="text-align: center;"
						>
							<vs-avatar
								style="border: 1px solid gray;"
								:text="getUserName(item.user_id)"
								:src="getCollaboratorAvatar(item.user_id)"
							/>
						</vx-tooltip>
					</vs-td>
                    <vs-td :id="'name' + item.id">{{ item.filename }}</vs-td>
                    <vs-td :id="'type' + item.id">{{ getTypeName(item.document_type_id) }}</vs-td>
                    <vs-td>{{ getDate(item.creation_date) }}</vs-td>
                    <vs-td :id="'link' + item.id">
                        <vx-tooltip :text="item.link" position="top">
                            <vs-button
                                size="large"
                                color="primary"
                                type="flat"
                                icon-pack="feather"
                                icon="icon-link-2"
                                @click="openLink(item.link)"
                            ></vs-button>
                        </vx-tooltip>
                    </vs-td>
                    <vs-td v-if="$acl.check('accountmanager') && !item.editmode" style="min-width: 100px;">
                        <vx-tooltip text="Modifier" position="top" style="float: left;">
                            <vs-button
                                size="large"
                                color="primary"
                                type="flat"
                                icon-pack="feather"
                                icon="icon-edit-2"
                                @click="item.editmode=true;$forceUpdate();updateDoc(item)"
                            ></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Supprimer" position="top" style="float: left;">
                            <vs-button
                                size="large"
                                color="danger"
                                type="flat"
                                icon-pack="feather"
                                icon="icon-trash-2"
                                @click="displayValidationPopup(item.id)"
                            ></vs-button>
                        </vx-tooltip>
                    </vs-td>
                    <vs-td v-if="$acl.check('accountmanager') && item.editmode" style="min-width: 100px;">
                        <vx-tooltip text="Enregistrer" position="top" style="float: left;">
                            <vs-button
                                size="large"
                                color="primary"
                                type="flat"
                                icon-pack="feather"
                                icon="icon-save"
                                @click="saveDoc(item.id)"
                            ></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Annuler" position="top" style="float: left;">
                            <vs-button
                                size="large"
                                color="danger"
                                type="flat"
                                icon-pack="feather"
                                icon="icon-x"
                                @click="cancelEdit()"
                            ></vs-button>
                        </vx-tooltip>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</template>

<script>
import Vue from "vue";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import VueCookies from "vue-cookies";
import DeletePopupVue from "../popups/DeletePopup.vue";
export default {
	name: "ShareLinkTable",
	components: {
	},
	props: {
		allLinks: Array,
		apiUrl: String,
	},
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			docList: []
		};
	},
	created(){
		store.dispatch("getAllUsers");
		this.docList = this.$props.allLinks;
		//console.log("linkssss", this.docList);

		for(let i = 0; i < this.docList.length; i++){
			this.docList[i]["editmode"] = false;
		}
	},
	computed: {
		allDocType(){
			return store.state.docTypeList;
		},
		activeUser(){
			return VueCookies.get("userInfo");
		},
		typeList: () => {
			return store.state.docTypeList;
		},
		users: () => {
			return store.state.users;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		}
	},
	watch: {
		allLinks: function(data){
			this.docList = data;
			for(let i = 0; i < this.docList.length; i++){
				this.docList[i]["editmode"] = false;
			}
		}
	},
	methods: {
		getCollaboratorAvatar(userId){
			let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
			if(foundAvatar) return foundAvatar.avatar;
			else return null;
		},
		getDate(date){
			return date.substr(8, 2) + "/" + date.substr(5, 2) + "/" + date.substr(0, 4) + " " + date.substr(11, 5);
		},
		getUserName(user_id){
			let foundUser = this.users.findIndex(row => row.id == user_id);
			let userName = " ";
			if(foundUser >= 0) userName = this.users[foundUser].firstname + " " + this.users[foundUser].lastname;
			return userName;
		},
		openLink(link){
			window.open(link, "_blank");
		},
		updateDoc(doc){
			document.getElementById("name" + doc.id).innerHTML = `<input placeholder="Nom du document" id="docName${doc.id}" value="${doc.filename}"/>`;

			document.getElementById("type" + doc.id).innerHTML = `<select id="docType${doc.id}"></select>`;

			for(let i = 0; i < this.typeList.length; i++){
				document.getElementById("docType" + doc.id).options.add(new Option(this.typeList[i].type_name, this.typeList[i].id));
				if(this.typeList[i].type_name == doc.type_name) document.getElementById("docType"+ doc.id).options[i].selected = true;
			}

			document.getElementById("link" + doc.id).innerHTML = `<input placeholder="Link" id="docLink${doc.id}" value="${doc.link}"/>`;
		},
		cancelEdit(){
			this.$emit("refresh-list");
		},
		saveDoc(docId){
			let regex = /^(?:ftp|http|https):\/\/(?:[\w\.\-\+]+:{0,1}[\w\.\-\+]*@)?(?:[a-z0-9\-\.]+)(?::[0-9]+)?(?:\/|\/(?:[\w#!:\.\?\+=&%@!\-\/\(\)]+)|\?(?:[\w#!:\.\?\+=&%@!\-\/\(\)]+))?$/;
			let errText = "";

			if(document.getElementById("docName" + docId).value == "") errText+= "Le nom du document ne peut être vide.\n";
			if(document.getElementById("docLink" + docId).value == "") errText+= "Le lien ne peut être vide.\n";
			if(!regex.test(document.getElementById("docLink" + docId).value) && document.getElementById("docLink" + docId).value !== "") errText+= "Le lien saisi n'est pas valide. (Préfixes: ftp/http/https)";

			if(errText !== ""){
				this.$vs.notify({
					title: "Erreur",
					text: errText,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning"
				});
			}
			else{
				this.$http.post(this.apiUrl + "shared_document/edit", {
					id: docId,
					filename: document.getElementById("docName" + docId).value,
					link: document.getElementById("docLink" + docId).value,
					document_type_id: document.getElementById("docType" + docId).selectedIndex + 1,
					user_id: this.activeUser.id
				})
					.then(() => {
						this.$emit("refresh-list");
					});
			}
		},
		displayValidationPopup(id){
			this.isConfirmDeletePopup = true;
			let ComponentClass = Vue.extend(DeletePopupVue);
			let deletePopupVue = new ComponentClass({
				propsData: {
					show: this.isConfirmDeletePopup,
				}
			});
			deletePopupVue.$mount();
			//emits whe user taps non
			deletePopupVue.$on("close-popup", (event) => {
				this.$emit("refresh-list");
				this.isConfirmDeletePopup = false;
			});
			//emits when user taps oui
			deletePopupVue.$on("oui", (event) => {
				this.$http.delete(this.apiUrl + "orders/delete/documentLink/" + id)
					.then(() => {
						this.$emit("refresh-list");
						this.isConfirmDeletePopup = false;
					}
					).catch((err) => {});
			});
			this.$refs.shareLinkTableContainer.appendChild(deletePopupVue.$el);


		},
		getTypeName(typeId){
			return this.allDocType.find(ele => ele.id == typeId).type_name;
		}
	}
};
</script>

<style scoped>
</style>
